import React from 'react';
import { getStaffPhotoUrl } from '../lib/fileUrls';

const AVATAR_COLORS = ['#1A56DB', '#15803D', '#D97706', '#DC2626', '#7C3AED', '#0D9488'];

const SIZES = {
  xs: 'w-6 h-6 text-xs',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-14 h-14 text-lg',
  xl: 'w-20 h-20 text-2xl',
};

export function getAvatarColor(userId) {
  if (!userId) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = userId.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function getUserInitials(user) {
  const first = user?.first_name || user?.name || '';
  const last = user?.last_name || '';
  if (first && last) return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  if (first) return first.charAt(0).toUpperCase();
  return '?';
}

export default function UserAvatar({ user, size = 'md', className = '' }) {
  const sz = SIZES[size] || SIZES.md;
  const color = getAvatarColor(user?.id);
  const initials = getUserInitials(user);
  const [imgError, setImgError] = React.useState(false);

  const photoUrl = user?.profile_photo;
  
  if (photoUrl && !imgError) {
    // Use the centralized helper to build the correct URL
    const fullUrl = getStaffPhotoUrl(photoUrl);
    return (
      <img
        src={fullUrl}
        alt={user.name || user.first_name || 'Usuario'}
        className={`${sz} rounded-full object-cover flex-shrink-0 ${className}`}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      className={`${sz} rounded-full flex items-center justify-center font-bold text-white flex-shrink-0 ${className}`}
      style={{ backgroundColor: color }}
      title={user?.name || user?.first_name}
    >
      {initials}
    </div>
  );
}
